export const curtText = (text = "", max) => {
  if(text.length >= max) {
    let newText = text.substring(0, max);
    newText += "...";
    return newText;
  } else {
    return text;
  }
}